import React, { useState } from 'react';
import styled from 'styled-components';
import { FiMenu, FiX } from 'react-icons/fi';
import logo from '/assets/Migrant-logo.png';

const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: f5f5f5; /* white base */
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  
  @media (min-width: 768px) {
    padding: 1rem 2rem;
    background: linear-gradient(to right, 
      #ffffff 0%, 
      #f1f1f1 50%,
      #f5f5f5 100%
    );
   
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  height: 60px;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  
  @media (min-width: 768px) {
    height: 80px;
    border-radius: 8px;
  }
`;

const MenuButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    font-size: 1.75rem;
    color: Black;
  }
  
  @media (min-width: 768px) {
    display: none;
  }
`;

const NavList = styled.ul`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #00A6D4; /* blue retas brand */
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 10;
  
  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    position: static;
    width: auto;
    background: transparent;
    box-shadow: none;
    gap: 1.5rem;
  }
`;

const NavItem = styled.li`
  border-bottom: 1px solid #008000;
  
  &:last-child {
    border-bottom: none;
  }
  
  a {
    display: block;
    text-decoration: none;
    color: Black;
    font-weight: 500;
    font-size: 1rem;
    padding: 1rem;
    text-align: center;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: #008000;
    }
  }

  @media (min-width: 768px) {
    border-bottom: none;
    
    a {
      padding: 0.5rem 0.75rem;
      font-weight: 600;
      position: relative;
      
      &:hover {
        background-color: transparent;
      }
      
      &::after {
        content: '';
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 50%;
        background-color: white;
        transition: all 0.3s ease;
      }
      
      &:hover::after {
        width: 100%;
        left: 0;
      }
    }
  }
`;

const Navigation = () => {
  const [open, setOpen] = useState(false);

  return (
    <Nav>
      <LogoContainer>
        <Logo src={logo} alt="RETAS Logo" />
      </LogoContainer>

      <MenuButton onClick={() => setOpen(!open)}>
        {open ? <FiX /> : <FiMenu />}
      </MenuButton>

      <NavList open={open}>
        <NavItem><a href="/">Home</a></NavItem>
        <NavItem><a href="/about-us">About Us</a></NavItem>
        <NavItem><a href="/what-we-do">What We Do</a></NavItem>
        <NavItem><a href="/i-need-help">I Need Help</a></NavItem>
        <NavItem><a href="/get-involved">Get Involved</a></NavItem>
        <NavItem><a href="/contact-us">Contact Us</a></NavItem>
         <NavItem><a href="/news">News</a></NavItem>
        <NavItem><a href="/library">Library</a></NavItem>
      </NavList>
    </Nav>
  );
};

export default Navigation;
